import React from 'react';
import Rhinocer1 from '../assets/img/pageimages/Rhinocer1.jpeg';
import Rhinocer2 from '../assets/img/pageimages/Rhinocer2.jpeg';
import Rhinocer3 from '../assets/img/pageimages/Rhinocer3.jpeg';

function Rhinocer() {
  return (
    <>
      <style>
        {`
          .rhino-container {
            font-family: 'Poppins', sans-serif;
            background-color: #f9fafb;
            padding: 4rem 0;
            margin: auto;
          }

          .rhino-header {
            text-align: center;
            margin-bottom: 40px;
          }

          .rhino-header h1 {
            font-weight: bold;
            color: #7620ff;
            margin-bottom: 10px;
          }

          .rhino-header p {
            color: #374151;
            margin: auto;
            max-width:80%;
          }

          .image-gallery {
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            justify-content: center;
            margin: 40px 0;
          }

          .image-gallery img {
            width: 100%;
            max-width: 350px;
            height: auto;
            border-radius: 10px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
          }

          .section {
            background-color: #ffffff;
            padding: 30px;
            margin: 30px auto;
            border-radius: 10px;
            max-width: 80%;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
          }

          .section h2 {
            font-weight: 600;
            color: #fdba00;
            margin-bottom: 15px;
          }

          .section p,
          .section li {
            color: #444;
            line-height: 1.6;
          }

          .section ul {
            padding-left: 20px;
            margin-top: 10px;
          }

          .highlight {
            background: linear-gradient(to right, #d1fae5, #a7f3d0);
            padding: 20px;
            margin-top: 40px;
            border-radius: 10px;
            font-weight: 500;
            color: #065f46;
            box-shadow: 0 2px 6px rgba(0,0,0,0.05);
          }
        `}
      </style>

      <div className="rhino-container">
        {/* Header */}
        <header className="rhino-header">
          <h1 style={{ marginTop: "3rem" }}>RhinocerOS3D Services</h1>
          <p>
            Rhinoceros 3D (Rhino) is a 3D modeling software used to create precise shapes for many industries. It’s based on Non-Uniform Rational Basis Splines (NURBS) geometry.
          </p>
        </header>

        {/* Image Gallery */}
        <div className="image-gallery">
          <img src={Rhinocer1} alt="Rhino Model 1" />
          <img src={Rhinocer2} alt="Rhino Model 2" />
          <img src={Rhinocer3} alt="Rhino Model 3" />
        </div>

        {/* What is Rhino 3D */}
        <section className="section">
          <h2>What is Rhino 3D?</h2>
          <p>
            Rhino 3D, or simply Rhino, is a 3D computer graphics and computer-aided design (CAD) software developed by Robert McNeel & Associates. It allows users to create, edit, analyze, and translate complex 3D models with high accuracy and precision.
          </p>
        </section>

        {/* Features */}
        <section className="section">
          <h2>Features</h2>
          <ul>
            <li><strong>NURBS modeling:</strong> Creates smooth, organic shapes with precise control over geometry</li>
            <li><strong>SubD tools:</strong> Creates and adjusts freeform and organic forms</li>
            <li><strong>Direct modeling tools:</strong> Creates basic planar solid geometry</li>
            <li><strong>Grasshopper:</strong> A visual programming environment integrated with the 3D modeling tools</li>
          </ul>
        </section>

        {/* Uses */}
        <section className="section">
          <h2>Uses</h2>
          <p>Rhino is used in a wide range of industries, including:</p>
          <ul>
            <li>Architecture</li>
            <li>Prototyping</li>
            <li>Engineering</li>
            <li>Jewelry and Industrial Design</li>
            <li>Graphic and Automotive Design</li>
            <li>Naval Design</li>
            <li>3D Printing and Reverse Engineering</li>
          </ul>
        </section>

        {/* Applications */}
        <section className="section">
          <h2>Applications</h2>
          <p>
            Rhino is popular among creative professionals across design disciplines due to its precision modeling capabilities.
            It’s favored where exact measurements and detail are essential for the final product.
          </p>
        </section>

        {/* History */}
        <section className="section">
          <h2>History</h2>
          <p>
            Rhino was invented in 1980 by Robert McNeel & Associates, an American company based in Barcelona, Spain.
            Rhino is compatible with most design, drafting, CAM, prototyping, rendering, and illustration programs.
          </p>
        </section>

     
      </div>
    </>
  );
}

export default Rhinocer;
